import React from 'react';
import '../styles/update-banner.css';

export default function UpdateBanner({ onReload }) {
  return (
    <div className="update-banner" role="status">
      <span>A new version is available.</span>
      <button className="update-banner-btn" onClick={onReload}>
        Refresh now
      </button>
    </div>
  );
}
